import { useLayoutEffect, useMemo } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop({ containerSelector }) {
  const { pathname } = useLocation();

  const isMobile = useMemo(() => {
    if (typeof window === "undefined") return false;
    return window.matchMedia("(max-width: 992px)").matches;
  }, []);

  const resolveContainer = () => {
    if (containerSelector) {
      const el = document.querySelector(containerSelector);
      if (el) return el;
    }
    return document.scrollingElement || document.documentElement; // okno/dokument
  };

  const scrollInstant = (el) => {
    if (!el) return;

    const html = document.documentElement;
    const prevHtmlSB = html.style.scrollBehavior;
    const prevElSB = el.style?.scrollBehavior;

    html.style.scrollBehavior = "auto";
    if (el !== html && el.style) el.style.scrollBehavior = "auto";

    if (el === window) {
      window.scrollTo(0, 0);
    } else if (typeof el.scrollTo === "function") {
      el.scrollTo(0, 0);
    } else {
      el.scrollTop = 0;
      el.scrollLeft = 0;
    }

    setTimeout(() => {
      html.style.scrollBehavior = prevHtmlSB;
      if (el !== html && el.style) el.style.scrollBehavior = prevElSB;
    }, 0);
  };

  useLayoutEffect(() => {
    const el = resolveContainer();
    scrollInstant(el);

    if (isMobile) {
      requestAnimationFrame(() => scrollInstant(el));
    }
  }, [pathname]);

  return null;
}
